import Featured_05 from "../components/ui/globe-feature-section";

export default function Demo() {
  return <Featured_05 />;
}
